import { render, staticRenderFns } from "./SettlementDashboardSkeleton.vue?vue&type=template&id=3e00f706"
import script from "./SettlementDashboardSkeleton.vue?vue&type=script&lang=js"
export * from "./SettlementDashboardSkeleton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports